import { useLocation } from 'react-router';
import type { Advert as AdvertType } from 'types/capi/plp';

import Tracked from '~/components/Tracked';
import useEnv from '~/hooks/useEnv';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';
import wct from '~/services/wct.client';
import { getTrackedUrlAndClickRef } from '~/utils/tracking';

type Props = {
  advert: AdvertType;
};

const Advert = ({ advert }: Props) => {
  const env = useEnv();
  const user = useUser();
  const { clientBrowser, clientIp, session } = useRootData();
  const { pathname, search } = useLocation();

  const pagePath = `${env.SITE_BASE_URL}${pathname}${search}`;

  const { url, clickRef } = getTrackedUrlAndClickRef(advert, { user });

  function onAdvertClick() {
    wct.fireEvent({
      clickRef,
      clientBrowser,
      clientIp,
      landingPage: 'plp',
      pagePath,
      session,
      url
    });
  }

  return (
    <div className="w-full bg-grey-tile pb-0 lg:pt-8">
      <Tracked.ExternalLink
        name="BLACKFRIDAY_BANNER"
        pagePosition="Banner"
        rel="sponsored nofollow noopener"
        target="_blank"
        href={url}
        variant="none"
        onClick={onAdvertClick}
      >
        <img
          alt={advert.image.alt}
          src={advert.image.url}
          className="mx-auto my-0"
        />
      </Tracked.ExternalLink>
    </div>
  );
};

export default Advert;
